// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file comun_enlaces.proto (package sextante.comun.enlaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file comun_enlaces.proto.
 */
export const file_comun_enlaces: GenFile = /*@__PURE__*/
  fileDesc("ChNjb211bl9lbmxhY2VzLnByb3RvEhlzZXh0YW50ZS5jb211bi5lbmxhY2VzLnYxIigKGVJlc29sdmVyR29vZ2xlTWFwc1JlcXVlc3QSCwoDdXJsGAEgASgJIjIKGlJlc29sdmVyR29vZ2xlTWFwc1Jlc3BvbnNlEhQKDHVybF9yZXN1ZWx0YRgBIAEoCTKUAQoORW5sYWNlc1NlcnZpY2USgQEKElJlc29sdmVyR29vZ2xlTWFwcxI0LnNleHRhbnRlLmNvbXVuLmVubGFjZXMudjEuUmVzb2x2ZXJHb29nbGVNYXBzUmVxdWVzdBo1LnNleHRhbnRlLmNvbXVuLmVubGFjZXMudjEuUmVzb2x2ZXJHb29nbGVNYXBzUmVzcG9uc2VCC6oCCEFwaS5HcnBjYgZwcm90bzM");

/**
 * Link acortado a resolver, como maps.app.goo.gl o goo.gl.
 *
 * @generated from message sextante.comun.enlaces.v1.ResolverGoogleMapsRequest
 */
export type ResolverGoogleMapsRequest = Message<"sextante.comun.enlaces.v1.ResolverGoogleMapsRequest"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * Describes the message sextante.comun.enlaces.v1.ResolverGoogleMapsRequest.
 * Use `create(ResolverGoogleMapsRequestSchema)` to create a new message.
 */
export const ResolverGoogleMapsRequestSchema: GenMessage<ResolverGoogleMapsRequest> = /*@__PURE__*/
  messageDesc(file_comun_enlaces, 0);

/**
 * Link completo despues de seguir la redireccion.
 *
 * @generated from message sextante.comun.enlaces.v1.ResolverGoogleMapsResponse
 */
export type ResolverGoogleMapsResponse = Message<"sextante.comun.enlaces.v1.ResolverGoogleMapsResponse"> & {
  /**
   * @generated from field: string url_resuelta = 1;
   */
  urlResuelta: string;
};

/**
 * Describes the message sextante.comun.enlaces.v1.ResolverGoogleMapsResponse.
 * Use `create(ResolverGoogleMapsResponseSchema)` to create a new message.
 */
export const ResolverGoogleMapsResponseSchema: GenMessage<ResolverGoogleMapsResponse> = /*@__PURE__*/
  messageDesc(file_comun_enlaces, 1);

/**
 * Migracion a gRPC-Web de la resolucion de links acortados de Google Maps (ver CLAUDE.md, seccion
 * migracion a gRPC-Web). Logica propia -no reusa IEnlaceGoogleMapsService/Services.Implementations,
 * que ademas es internal a ese assembly-: reimplementa la misma whitelist de hosts (SSRF) y el mismo
 * seguimiento de redireccion HTTP con HttpClient, mismo criterio que ClienteFincaWizardGrpcService.
 *
 * @generated from service sextante.comun.enlaces.v1.EnlacesService
 */
export const EnlacesService: GenService<{
  /**
   * Sigue la redireccion de un link acortado de Google Maps y devuelve el link completo. Link de otro dominio
   * o que no se puede resolver: InvalidArgument.
   *
   * @generated from rpc sextante.comun.enlaces.v1.EnlacesService.ResolverGoogleMaps
   */
  resolverGoogleMaps: {
    methodKind: "unary";
    input: typeof ResolverGoogleMapsRequestSchema;
    output: typeof ResolverGoogleMapsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_comun_enlaces, 0);

